'use client'

import { addReactError } from '@datadog/browser-rum-react'
import { SomethingWentWrong } from '@shared/components/SomethingWentWrong'
import { ROUTES } from '@shared/routes'
import { useEffect } from 'react'

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
	useEffect(() => {
		// eslint-disable-next-line no-console
		console.error(error)
		if (process.env.NODE_ENV === 'development') return
		addReactError(error, { componentStack: 'Missing Stack' })
	}, [error])

	return <SomethingWentWrong goBackHref={ROUTES.jobs.base} reset={reset} />
}
